export default "__VITE_ASSET__b69a4b46__"